import React, { useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import {
  Col,
  Card,
  Table,
  Dropdown,
  Modal,
  Alert,
  Spinner,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory,useParams,useLocation } from "react-router-dom";
function ViewFoodOrder(props) {
const {id}=useParams()
  var history = useHistory();
  const sort = 10;
  const activePag = useRef(0);
  const [data, setData] = useState([]);
  const [order, setOrder] = useState([]);
  const [orderId, setOrderId] = useState('');
  const [spinner, setSpinner] = useState(true);
  const [show, setShow] = useState(false);
  const [penaltyStatus,setPenaltyStatus] = useState(false);
  const [amount,setAmount] = useState(0);
  const [reason,setReason] = useState('');

  function getData() {
    axios
      .get(
        `${Baseurl.baseurl4}/go-food/get-all-completed-ongoing-order-details-by-restaurant-id/${id}/0`
      )
      .then((res) => {
        console.log('result',res)
        setSpinner(false);
        if (res.data.status) {

          setOrder(res.data.orderDetails);
          setData(document.querySelectorAll("#job_data tbody tr"))
        }
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };

  useEffect(() => {
    getData();
  }, []);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
function reversePenalty(){
  const params = {
    amount:parseInt(amount),
    orderId:orderId, 
  };
  axios
    .post(`${Baseurl.baseurl4}/go-food/reverse-restaurant-penalty/${id}`, params)
    .then((res) => {
      if (res.data.status) {
        swal("Reversed", res.data.message, "success", {
          button: "Done",
          timer: 1000,
        });
        getData()
      } else {
        swal("Oops", res.data.message, "error", {
          button: "Done",
          timer: 1000,
        });
      }

      setShow(false)
    })
    .catch((err) => {
    
    });
}
function addPenalty(){
  const params = {
    amount:parseInt(amount),
    orderId:orderId, 
    reason:reason
  };
  axios
    .post(`${Baseurl.baseurl4}/go-food/add-restaurant-penalty/${id}`, params)
    .then((res) => {
      if (res.data.status) {
        swal("Added", res.data.message, "success", {
          button: "Done",
          timer: 1000,
        });
        getData()
      } else {
        swal("Oops", res.data.message, "error", {
          button: "Done",
          timer: 1000,
        });
      }

      setShow(false)
    })
    .catch((err) => {
    
    });
}
  return (
    <Col lg={12}>
      <Modal
        size="lg"
        show={show}
        onHide={() => {
          setShow(false);
        }}
      >
        <Modal.Body>
          {penaltyStatus?(
            <div className="row">
              <div className="col-sm-2 mt-2">
                Penalty Amount
              </div>
                <div className="col-sm-4">
                <input
                  value={amount}
                  type="number"
                  className="form-control"
                  placeholder="enter amount"
                  onChange={(e) => setAmount(e.target.value)}
                  required
                />
              </div>
              <div className="col-sm-2 mt-2">
                Reason
              </div>
                <div className="col-sm-4">
                <input
                  value={reason}
                  type="text"
                  className="form-control"
                  placeholder="enter reason"
                  onChange={(e) => setReason(e.target.value)}
                  required
                />
              </div>
            </div>
          ):(
            <div className="row">
            <div className="col-sm-2 mt-2">
               Amount
            </div>
              <div className="col-sm-4">
              <input
                value={amount}
                type="number"
                className="form-control"
                placeholder="enter amount"
                onChange={(e) => setAmount(e.target.value)}
                required
              />
            </div>
           
          </div>

          )}
        </Modal.Body>
        <Modal.Footer>
        {penaltyStatus?(
          <button
          onClick={()=>{addPenalty()}}
          className="btn btn-primary">Add</button>):(
            <button
            onClick={()=>{reversePenalty()}}
            className="btn btn-primary">Reverse</button>
        )}
        </Modal.Footer>
      </Modal>
      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
         <Card.Header>
             <div></div>
            <button className="btn btn-primary " onClick={()=>{history.goBack()}}>Back</button>
           </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white" responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>Order Id</strong>
                    </th>
                    <th>
                      <strong>Date</strong>
                    </th>
                    <th>
                      <strong>Hour</strong>
                    </th>
                  
                    <th>
                      <strong>Minute</strong>
                    </th>
                    <th>
                      <strong>status</strong>
                    </th>
                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {order &&
                    order.map((item, key) => (
                      <tr key={item.orderId}>
                        <td>{item.orderId}</td>
                        <td>{item.date}</td>
                        <td>{item.hour}</td>
                        <td>{item.minute}</td>
                        <td>{item.orderStatus}</td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                             
                              <Dropdown.Item
                                onClick={() => {
                                    setShow(true)
                                    setPenaltyStatus(true)
                                    setOrderId(item.orderId)
                                }}
                              >
                               Add Penalty
                              </Dropdown.Item>
                           
                              <Dropdown.Item
                                onClick={() => {
                                 setShow(true)
                                 setOrderId(item.orderId)
                                 setPenaltyStatus(false)
                                }}
                              >
                              Reverse Penalty
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  history.push(`/food-order-details/${item.orderId}`);
                                }}
                              >
                              View Order
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}

            {!order && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero order
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default ViewFoodOrder;

